import { useMemo } from "react";

import { AiIntegrationsBulkActionItem } from "../types";
import useDisableAiIntegrationBulkAction from "./useDisableAiIntegrationBulkAction";
import useEnableAiIntegrationBulkAction from "./useEnableAiIntegrationBulkAction";

const useAiIntegrationsBulkActions = (): AiIntegrationsBulkActionItem[] => {
  const enableAiIntegrationBulkAction = useEnableAiIntegrationBulkAction();
  const disableAiIntegrationBulkAction = useDisableAiIntegrationBulkAction();

  return useMemo(
    () => [enableAiIntegrationBulkAction, disableAiIntegrationBulkAction],
    [enableAiIntegrationBulkAction, disableAiIntegrationBulkAction]
  );
};

export default useAiIntegrationsBulkActions;
